export default "__VITE_ASSET__9f20683d__$_?nuxt_component=async__"